
import {
  mdiSlashForward,
  mdiArrowCollapseLeft,
  mdiArrowLeft,
  mdiArrowRight,
  mdiArrowCollapseRight
} from '@mdi/js';
export default {
  props: {
    total: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    rowPerPage: {
      type: Number,
      required: true
    },
    defaultBatchSize: {
      type: Number
    },
    path: {
      type: String,
      required: true
    },
    sort: {
      type: String
    },
    queryParams: {
      type: Object
    },
    batchSizeMultiple: {
      type: Number,
      default: 5
    }
  },
  data() {
    return {
      icons: {
        mdiSlashForward,
        mdiArrowCollapseLeft,
        mdiArrowLeft,
        mdiArrowRight,
        mdiArrowCollapseRight
      },
      maxVisibleButtons: 4,
      batchSize: this.defaultBatchSize || 5
    };
  },
  watch: {
    rowPerPage(v) {
      this.batchSize = v;
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.rowPerPage);
    },
    rowItems() {
      return [].concat.apply(
        [this.batchSizeMultiple],
        Array(10)
          .fill(1)
          .map((x, y) => (x + y) * this.batchSizeMultiple)
      );
    },
    startPage() {
      // When on the first page
      if (this.currentPage === 1) {
        return 1;
      }

      // When on the last page
      if (this.currentPage === this.totalPages) {
        let val = this.totalPages - this.maxVisibleButtons;
        return val <= 0 ? 1 : val;
      }

      // When inbetween
      return this.currentPage - 1;
    },
    pages() {
      const range = [];
      for (
        // let i = this.startPage;
        // i <= Math.min(this.startPage + this.maxVisibleButtons, this.totalPages);
        let i = 1;
        i <= this.totalPages;
        i++
      ) {
        const hide =
          i < this.startPage ||
          i >
            Math.min(this.startPage + this.maxVisibleButtons, this.totalPages);

        range.push({
          name: i,
          isDisabled: i === this.currentPage,
          hide
        });
      }

      return range;
    },
    isInFirstPage() {
      return this.currentPage === 1;
    },
    isInLastPage() {
      return this.currentPage === this.totalPages;
    }
  },
  methods: {
    onClickBatch() {
      // this.$emit('pagechanged', 1, this.batchSize);
      this.$emit('bathSizeChanged', 1, this.batchSize);
    },
    onClickFirstPage() {
      this.$emit('pagechanged', 1);
    },
    onClickPreviousPage() {
      this.$emit('pagechanged', this.currentPage - 1);
    },
    onClickPage(page) {
      this.$emit('pagechanged', page);
    },
    onClickNextPage() {
      this.$emit('pagechanged', this.currentPage + 1);
    },
    onClickLastPage() {
      this.$emit('pagechanged', this.totalPages);
    },
    isPageActive(page) {
      return this.currentPage === page;
    }
  }
};
